import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { MutableRefObject } from 'react';

/**
 * DataGrid の行選択を完全に解除する。
 *
 * 選択カウント表示(フッター)はグリッド内部の選択モデルを参照するため、呼び出し側の
 * selectedIds state を空にするだけでは残る。加えて keepNonExistentRowsSelected 有効時は
 * 削除で消えた行の選択も保持されるため、apiRef 経由で選択モデルを明示的に空へ戻す。
 */
export const clearRowSelection = (
  apiRef: MutableRefObject<GridApiPremium>,
  setSelectedIds: (ids: number[]) => void,
) => {
  setSelectedIds([]);
  apiRef.current.setRowSelectionModel({ ids: new Set(), type: 'include' });
};
